import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * Scrolls to the element matching location.hash whenever the location changes.
 * Also scrolls to top when navigating to a route with no hash.
 */
export function ScrollToHash() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      // Small delay so the target route's content has rendered
      const id = hash.replace('#', '');
      const tryScroll = (attempt = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        } else if (attempt < 10) {
          // Retry briefly in case the section is still mounting
          setTimeout(() => tryScroll(attempt + 1), 50);
        }
      };
      tryScroll();
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'instant' as ScrollBehavior
      });
    }
  }, [pathname, hash]);
  return null;
}